var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['product-promo', ("product-promo_" + (_vm.countProduct)), ("product-promo_product-" + (_vm.productAlign))]
  }, [_vm._l(_vm.items, function (item, index) {
    var _item$price, _item$price2, _item$image, _item$image2, _item$image3, _item$price3;

    return [_vm.countProduct > index ? _c('GGLink', {
      key: index,
      staticClass: "product-promo__item",
      attrs: {
        "to": item.path,
        "data-e2e": "promo-product-card"
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.$emit('link-click');
        }
      }
    }, [(_item$price = item.price) !== null && _item$price !== void 0 && _item$price.bonusIncome || (_item$price2 = item.price) !== null && _item$price2 !== void 0 && _item$price2.discount ? [item.price.bonusIncome ? _c('BonusCount', {
      staticClass: "product-promo__labels product-promo__labels_bonus",
      attrs: {
        "count": item.price.bonusIncome,
        "size": "regular"
      }
    }) : _vm._e(), _vm._v(" "), item.price.discount ? _c('ProductDiscountMarker', {
      staticClass: "product-promo__labels product-promo__labels_discount",
      attrs: {
        "price": item.price.discount.value,
        "discount": item.price.common.value
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "product-promo__wrap-img"
    }, [_c('img', {
      staticClass: "product-promo__img",
      attrs: {
        "src": (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.x1,
        "srcset": ((_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.x2) && (((_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.x2) + " 2x"),
        "alt": item.name
      }
    })]), _vm._v(" "), item.name ? _c('div', {
      staticClass: "product-promo__title"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _vm._v(" "), (_item$price3 = item.price) !== null && _item$price3 !== void 0 && _item$price3.common.value ? _c('GGPrice', {
      staticClass: "product-promo__price",
      attrs: {
        "price": item.price,
        "size": index === 0 ? 'big' : 'small',
        "promo": ""
      }
    }) : _vm._e()], 2) : _vm._e()];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }